import { useEffect, useMemo, useRef, useState } from 'react'

export function useElementWidth<T extends HTMLElement>(divisor = 1) {
  const ref = useRef<T | null>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const ro = new ResizeObserver(entries => {
      const w = entries[0]?.contentRect?.width ?? 0
      setWidth(w)
    })

    ro.observe(el)
    setWidth(el.getBoundingClientRect().width)

    return () => ro.disconnect()
  }, [])

  const itemWidth = useMemo(() => (width ? Math.floor(width / divisor) : 0), [width, divisor])

  return { ref, itemWidth }
}
